export default __webpack_public_path__ + "static/media/CTE_Logo.66d44323.svg";